import { State } from '../../types'

export function getIsLogin(state: State) {
	return state.Auth.authorized
}
